import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer1 from "../components/Footer1";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./MyOffers.css";

const MyOffers = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedOffer, setSelectedOffer] = useState(null);
  
  // Modal States
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showCounterModal, setShowCounterModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Offer Update State
  const [newOfferPrice, setNewOfferPrice] = useState("");
  const [newOfferNote, setNewOfferNote] = useState("");

  // Payment & Order State
  const [paymentMethod, setPaymentMethod] = useState("ONLINE");
  const [processingPayment, setProcessingPayment] = useState(false);
  const [confirmedOrderDetails, setConfirmedOrderDetails] = useState(null);

  const navigate = useNavigate();

  // Address Form Fields
  const [addressForm, setAddressForm] = useState({
    fullName: "", 
    mobile: "", 
    pincode: "",
    city: "",
    state: "",
    country: "India",
    addressLine: "",
    landmark: "",
  });

  const token = localStorage.getItem("authToken");

  const fetchOffers = async () => {
    try {
      const res = await axios.get("http://localhost:8080/api/offers/my", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const formattedOffers = res.data.map((offer) => {
        let title = "Unknown Artwork";
        let artist = "Anjaan Vivek";
        let imageUrl = "/assets/Paintings/main-bg.png"; 

        if (offer.seriesOffer) {
            title = `${offer.seriesName} (Complete Series)`;
        } else if (offer.painting) {
            title = offer.painting.title;
            artist = offer.painting.artist;
            if (offer.painting.images && offer.painting.images.length > 0) {
                imageUrl = offer.painting.images[0].imageUrl;
            }
        }

        return {
            id: offer.id,
            offeredPrice: offer.offerAmount,
            status: offer.status || "PENDING",
            seriesOffer: offer.seriesOffer,
            painting: {
                id: offer.painting?.id, 
                title: title,
                artist: artist,
                image: imageUrl,
            },
            history: [], 
        };
      });

      setOffers(formattedOffers);
      formattedOffers.forEach((offer) => fetchOfferHistory(offer.id));

    } catch (err) {
      console.error("Error fetching offers:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchOfferHistory = async (offerId) => {
    try {
      const res = await axios.get(
        `http://localhost:8080/api/offers/history/${offerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setOffers((prev) =>
        prev.map((offer) =>
          offer.id === offerId ? { ...offer, history: res.data } : offer
        )
      );
    } catch (err) {
      console.error("Error fetching history:", err);
    }
  };

  useEffect(() => {
    fetchOffers();
    window.scrollTo(0, 0);
  }, []);

  const toggleRow = (id) =>
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));

  // --- ACTIONS ---

  const handleBuyNowClick = (e, offer) => {
    e.stopPropagation();
    setSelectedOffer(offer);
    setShowPurchaseModal(true);
  };

  const handleCounterClick = (e, offer) => {
    e.stopPropagation();
    setSelectedOffer(offer);
    setNewOfferPrice(offer.offeredPrice);
    setNewOfferNote("");
    setShowCounterModal(true);
  };

  const handleConfirmCounter = async () => {
    if (!newOfferPrice || isNaN(newOfferPrice) || newOfferPrice <= 0) {
      alert("Please enter a valid offer price.");
      return;
    }

    try {
      let url = "";
      let payload = {
          offerAmount: newOfferPrice,
          message: newOfferNote,
          offerId: selectedOffer.id,
      };

      if (selectedOffer.seriesOffer) {
          url = `http://localhost:8080/api/offers/make/series`;
          payload.seriesName = selectedOffer.painting.title.replace(" (Complete Series)", ""); 
      } else {
          url = `http://localhost:8080/api/offers/make/${selectedOffer.painting.id}`;
      }

      await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert(`✅ Offer updated successfully!`);
      fetchOffers();
      setShowCounterModal(false);
    } catch (err) {
      console.error("Error submitting offer:", err);
      alert("Failed to submit offer.");
    }
  };

  // --- PAYMENT & ORDER LOGIC ---

  const handleConfirmPurchase = async () => {
    const { fullName, mobile, pincode, city, state, country, addressLine } = addressForm;

    if (!fullName || !mobile || !pincode || !city || !state || !country || !addressLine) {
      alert("Please fill all required address fields.");
      return;
    }

    setProcessingPayment(true);

    try {
      // ✅ CREATE ORDER LINKED TO OFFER
      const res = await axios.post(
        "http://localhost:8080/api/orders/create",
        {
          address: { ...addressForm },
          paymentMethod: paymentMethod,
          offerId: selectedOffer.id 
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;

      if (data.status === "COD_SUCCESS") {
        setConfirmedOrderDetails({
          orderId: data.orderId,
          amount: data.amount * 100, 
        });
        handleOrderSuccess();
      } else {
        // Online Payment
        const { orderId, amount, currency, razorpayOrderId, razorpayKey } = data;
        setConfirmedOrderDetails({ orderId, amount }); 

        const options = {
          key: razorpayKey || "rzp_test_RhhFBGZOn8aQPO",
          amount: amount,
          currency: currency || "INR",
          name: "Anjaan’s World",
          description: `Order #${orderId}`,
          order_id: razorpayOrderId,
          handler: async function (response) {
            try {
              await axios.post(
                "http://localhost:8080/api/orders/confirm",
                {
                  orderId: orderId.toString(),
                  razorpayPaymentId: response.razorpay_payment_id,
                  razorpayOrderId: response.razorpay_order_id,
                  razorpaySignature: response.razorpay_signature,
                },
                { headers: { Authorization: `Bearer ${token}` } }
              );
              handleOrderSuccess();
            } catch (err) {
              alert("Payment verification failed.");
              setProcessingPayment(false);
            }
          },
          prefill: {
            name: fullName,
            contact: mobile,
          },
          theme: { color: "#88b019" },
        };

        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", function (response) {
          alert("Payment Failed: " + response.error.description);
          setProcessingPayment(false);
        });
        rzp.open();
      }
    } catch (err) {
      console.error("Order creation failed:", err);
      alert(err.response?.data?.message || "Failed to create order.");
      setProcessingPayment(false);
    }
  };

  const handleOrderSuccess = () => {
    setShowPurchaseModal(false);
    setShowSuccessModal(true);
    setProcessingPayment(false);
    fetchOffers(); // Refresh to see status change to ORDERED
  };

  if (loading) return <div className="loading-div"><div className="spinner"></div></div>;

  return (
    <>
      <div className="top_banner_">
        <h1>My Offers</h1>
        <p>Track negotiations and finalize your collection.</p>
      </div>

      <div className="offers-container">
        
        {offers.length === 0 ? (
            <div className="no-offers-state">
                <h3>You haven't made any offers yet.</h3>
                <button onClick={() => navigate("/allPaintings")}>Explore Gallery</button>
            </div>
        ) : (
            <div className="offers-table-container">
            <table className="offers-table">
                <thead>
                <tr>
                    <th>Artwork</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Your Offer</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {offers.map((offer) => (
                    <React.Fragment key={offer.id}>
                    <tr onClick={() => toggleRow(offer.id)} className="table-row">
                        <td>
                        <img
                            src={offer.painting.image}
                            alt={offer.painting.title}
                            className="offer-image-thumb"
                        />
                        </td>
                        <td className="title-cell">
                            {offer.painting.title}
                            <span className="artist-sub">{offer.painting.artist}</span>
                        </td>
                        <td>
                            <span className={`badge ${offer.seriesOffer ? "badge-series" : "badge-single"}`}>
                                {offer.seriesOffer ? "Series Bundle" : "Single"}
                            </span>
                        </td>
                        <td className="price-cell">₹ {offer.offeredPrice.toLocaleString("en-IN")}</td>
                        <td>
                        <span className={`status-pill status-${offer.status.toLowerCase()}`}>
                            {offer.status}
                        </span>
                        </td>
                        <td>
                        
                        {/* ✅ UPDATED LOGIC FOR ACTIONS */}
                        {offer.status === "ORDERED" ? (
                             // 1. ORDER COMPLETED -> Go to Orders Page
                             <button
                                className="btn-view-order"
                                onClick={(e) => { e.stopPropagation(); navigate("/myOrders"); }}
                            >
                                View Order
                            </button>
                        ) : (offer.status === "ACCEPTED" || offer.status === "COUNTERED") ? (
                            // 2. ACCEPTED / COUNTERED -> Buy Now
                            <div className="action-buttons-stack">
                                <button
                                    className="btn-buy-now"
                                    onClick={(e) => handleBuyNowClick(e, offer)}
                                >
                                    {offer.status === "ACCEPTED" ? "Buy Now" : "Accept & Buy"}
                                </button>
                                
                                {offer.status === "COUNTERED" && (
                                    <button
                                        className="btn-counter-link"
                                        onClick={(e) => handleCounterClick(e, offer)}
                                    >
                                        Counter Back
                                    </button>
                                )}
                            </div>
                        ) : (offer.status !== "REJECTED" && offer.status !== "PAID") ? (
                            // 3. PENDING -> Update Offer
                            <button
                                className="btn-counter"
                                onClick={(e) => handleCounterClick(e, offer)}
                            >
                                Update Offer
                            </button>
                        ) : (
                            // 4. CLOSED
                            <span className="action-closed">—</span>
                        )}

                        </td>
                    </tr>

                    {expandedRows[offer.id] && (
                        <tr className="expand-row">
                        <td colSpan="6">
                            <div className="history-box">
                            <h4>Negotiation History</h4>
                            <div className="history-timeline">
                                {offer.history.length === 0 ? (
                                <p>No negotiation history yet.</p>
                                ) : (
                                offer.history.map((h, i) => (
                                    <div key={i} className={`history-item ${h.role === 'ARTIST' ? 'artist-msg' : 'buyer-msg'}`}>
                                    <div className="history-dot"></div>
                                    <p>
                                        <strong>{h.role === 'ARTIST' ? 'Artist' : 'You'}</strong>: ₹{h.price.toLocaleString("en-IN")}
                                    </p>
                                    {h.note && <span className="history-note">"{h.note}"</span>}
                                    <span className="history-date">{new Date(h.date).toLocaleDateString()}</span>
                                    </div>
                                ))
                                )}
                            </div>
                            </div>
                        </td>
                        </tr>
                    )}
                    </React.Fragment>
                ))}
                </tbody>
            </table>
            </div>
        )}
      </div>

      {/* 🏠 Purchase Modal */}
      {showPurchaseModal && selectedOffer && (
        <div className="offer-modal-overlay">
          <div className="offer-modal-box scrollable-modal">
            <h2 className="offer-modal-title">Complete Purchase</h2>
            <div className="modal-item-summary">
                <img src={selectedOffer.painting.image} alt="art" />
                <div>
                    <h4>{selectedOffer.painting.title}</h4>
                    <p className="final-price-tag">Agreed Price: ₹ {selectedOffer.offeredPrice.toLocaleString("en-IN")}</p>
                </div>
            </div>

            <form className="address-form" onSubmit={(e) => e.preventDefault()}>
              <h4>Shipping Details</h4>
              <div className="form-row">
                <input type="text" placeholder="Full Name" value={addressForm.fullName} onChange={(e) => setAddressForm({ ...addressForm, fullName: e.target.value })} />
                <input type="text" placeholder="Mobile Number" value={addressForm.mobile} onChange={(e) => setAddressForm({ ...addressForm, mobile: e.target.value })} />
              </div>
              <div className="form-row">
                <input type="text" placeholder="Pincode" value={addressForm.pincode} onChange={(e) => setAddressForm({ ...addressForm, pincode: e.target.value })} />
                <input type="text" placeholder="City" value={addressForm.city} onChange={(e) => setAddressForm({ ...addressForm, city: e.target.value })} />
              </div>
              <div className="form-row">
                <input type="text" placeholder="State" value={addressForm.state} onChange={(e) => setAddressForm({ ...addressForm, state: e.target.value })} />
                <input type="text" placeholder="Country" value={addressForm.country} onChange={(e) => setAddressForm({ ...addressForm, country: e.target.value })} />
              </div>
              <textarea placeholder="Full Address (House No, Street, Area)" value={addressForm.addressLine} onChange={(e) => setAddressForm({ ...addressForm, addressLine: e.target.value })} ></textarea>
            </form>

            <div className="payment-selection">
              <h4>Payment Method</h4>
              <label className={`payment-option ${paymentMethod === "ONLINE" ? "selected" : ""}`}>
                <input type="radio" value="ONLINE" checked={paymentMethod === "ONLINE"} onChange={() => setPaymentMethod("ONLINE")} />
                <span>Online (Cards, UPI)</span>
              </label>
              <label className={`payment-option ${paymentMethod === "COD" ? "selected" : ""}`}>
                <input type="radio" value="COD" checked={paymentMethod === "COD"} onChange={() => setPaymentMethod("COD")} />
                <span>Cash on Delivery</span>
              </label>
            </div>

            <div className="offer-modal-actions">
              <button className="offer-btn-primary" onClick={handleConfirmPurchase} disabled={processingPayment}>
                {processingPayment ? "Processing..." : `Pay ₹${selectedOffer.offeredPrice.toLocaleString("en-IN")}`}
              </button>
              <button className="offer-btn-secondary" onClick={() => setShowPurchaseModal(false)} disabled={processingPayment}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* 📝 Counter/Update Modal */}
      {showCounterModal && selectedOffer && (
        <div className="offer-modal-overlay">
          <div className="offer-modal-box">
            <h2 className="offer-modal-title">Update Your Offer</h2>
            <p className="offer-modal-subtext">For: <strong>{selectedOffer.painting.title}</strong></p>
            <div className="modal-input-group">
                <label>New Price (₹)</label>
                <input type="number" value={newOfferPrice} onChange={(e) => setNewOfferPrice(e.target.value)} />
            </div>
            <div className="modal-input-group">
                <label>Note to Artist</label>
                <textarea value={newOfferNote} onChange={(e) => setNewOfferNote(e.target.value)} placeholder="Reason for update..."></textarea>
            </div>
            <div className="offer-modal-actions">
              <button className="offer-btn-primary" onClick={handleConfirmCounter}>Update</button>
              <button className="offer-btn-secondary" onClick={() => setShowCounterModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Success Modal */}
      {showSuccessModal && (
        <div className="success_modal_overlay">
          <div className="success_modal_content">
            <div className="success_icon_circle"><i className="fa-solid fa-check"></i></div>
            <h2>Order Placed!</h2>
            <div className="order_summary_box">
                <div className="summary_row"><span>Order ID:</span><strong>#{confirmedOrderDetails?.orderId}</strong></div>
                <div className="summary_row"><span>Amount:</span><strong>₹ {(confirmedOrderDetails?.amount / 100).toLocaleString("en-IN")}</strong></div>
            </div>
            <div className="modal_buttons">
              <button className="offer-btn-secondary" onClick={() => navigate("/myOrders")}>View Orders</button>
              <button className="offer-btn-primary" onClick={() => navigate("/")}>Home</button>
            </div>
          </div>
        </div>
      )}

      <Footer1 />
    </>
  );
};

export default MyOffers;